export const getters = {
  getFavouriteMode(state) {
    return state.favouriteMode;
  },
  getSendingFavRequest(state) {
    return state.sendingFavRequest;
  }
};
